/*
 * Fraunhofer Institute for Computer Graphics Research (IGD)
 * Competence Center for Information Visualization and Visual Analytics
 *
 * Copyright (c) 2018 Fraunhofer IGD. All rights reserved.
 *
 * This source code is property of the Fraunhofer IGD and underlies
 * copyright restrictions. It may only be used with explicit
 * permission from the respective owner.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { arrayBufferPromiseDELETE, arrayBufferPromiseGET, arrayBufferPromisePATCH, arrayBufferPromisePOST, arrayBufferPromisePUT, blobPromiseDELETE, blobPromiseGET, blobPromisePATCH, blobPromisePOST, blobPromisePUT, jsonPromiseDELETE, jsonPromiseGET, jsonPromisePATCH, jsonPromisePOST, jsonPromisePUT, textPromiseDELETE, textPromiseGET, textPromisePATCH, textPromisePOST, textPromisePUT } from './RestServicePromiseUtils';
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  resultCallbackFunc(data): Returns the data send by the REST service as json object
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonGET(endpoint, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = jsonPromiseGET(endpoint, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PUT-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as json object
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPUT(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = jsonPromisePUT(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as json object
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPOST(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = jsonPromisePOST(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the DELETE-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as json object
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonDELETE(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = jsonPromiseDELETE(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as json object
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPATCH(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = jsonPromisePATCH(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
*  endpoint: The endpoint of the REST-Service, e.g. /api/time
*  resultCallbackFunc(data): Returns the data send by the REST service as text
*  errorCallbackFunc(errorMessage): Returns the error message (optional)
*  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
*/
export function textGET(endpoint, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = textPromiseGET(endpoint, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PUT-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as text
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPUT(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = textPromisePUT(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as text
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPOST(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = textPromisePOST(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the DELETE-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as text
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textDELETE(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = textPromiseDELETE(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as text
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPATCH(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = textPromisePATCH(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  resultCallbackFunc(data): Returns the data send by the REST service as array buffer
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferGET(endpoint, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = arrayBufferPromiseGET(endpoint, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PUT-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as array buffer
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPUT(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = arrayBufferPromisePUT(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as array buffer
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPOST(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = arrayBufferPromisePOST(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the DELETE-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as array buffer
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferDELETE(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = arrayBufferPromiseDELETE(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as array buffer
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPATCH(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = arrayBufferPromisePATCH(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  resultCallbackFunc(data): Returns the data send by the REST service as blob
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobGET(endpoint, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = blobPromiseGET(endpoint, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PUT-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as blob
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPUT(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = blobPromisePUT(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as blob
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPOST(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = blobPromisePOST(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the DELETE-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as blob
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobDELETE(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = blobPromiseDELETE(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  resultCallbackFunc(data): Returns the data send by the REST service as blob
 *  errorCallbackFunc(errorMessage): Returns the error message (optional)
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPATCH(endpoint, bodyContentObj, resultCallbackFunc, errorCallbackFunc, additionalOptions) {
    const promise = blobPromisePATCH(endpoint, bodyContentObj, additionalOptions);
    mapPromise(promise, resultCallbackFunc, errorCallbackFunc);
}
function mapPromise(promise, resultCallbackFunc, errorCallbackFunc) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            resultCallbackFunc(yield promise);
        }
        catch (error) {
            if (errorCallbackFunc) {
                errorCallbackFunc(error);
            }
            else {
                console.error(error.message);
            }
        }
    });
}
//# sourceMappingURL=RestServiceUtils.js.map